export default "__VITE_ASSET__BVJSZWbO__"